import { CarrierELDApps } from '../_components/carrier-eld-apps'
import { CarrierLoginFlow } from '../_components/carrier-login-flow'
import { CarrierMCOrDOTVerification } from '../_components/carrier-mc-dot-verification'
import { CarrierUserWorkspaceDetails } from '../_components/carrier-user-workspace-details'
import type { ICarrierOnboardingStep } from '../_types'

export const carrierOnboardingSteps: ICarrierOnboardingStep[] = [
  {
    content: <CarrierLoginFlow />,
    id: 'login',
    label: 'Login or Sign Up'
  },
  {
    content: <CarrierMCOrDOTVerification />,
    id: 'mc_dot',
    label: 'Verify MC/DOT number'
  },
  {
    content: <CarrierELDApps />,
    id: 'eld_setup',
    label: 'Connect ELD application'
  },
  {
    content: <CarrierUserWorkspaceDetails />,
    id: 'user_workspace_details',
    label: 'Setup your company details'
  }
]

/**
 * Filter carrier onboarding steps based on user access type
 * Members cannot access the workspace details step
 */
export const getFilteredCarrierOnboardingSteps = (accessType?: string): ICarrierOnboardingStep[] => {
  if (accessType === 'Member') {
    return carrierOnboardingSteps.filter((step) => step.id !== 'user_workspace_details')
  }
  return carrierOnboardingSteps
}

/**
 * Get incomplete steps from filtered steps
 */
export const getIncompleteSteps = (accessType?: string, completedStepIDs: string[] = []): ICarrierOnboardingStep[] => {
  return getFilteredCarrierOnboardingSteps(accessType).filter((step) => !completedStepIDs.includes(step.id))
}
